export default {
  OPEN_LESSON: "openLesson",
  REFRESHED_JOURNAL: "refreshedJournal",
};
